import { useDeviceSetting } from './useDeviceSetting';

/**
 * Whether the production line is drawn top to bottom, one stage under the
 * other, instead of left to right. The request of 5 October 2026 (third),
 * section 9.
 *
 * One choice for the Overview and for the Production line screen, remembered on
 * the device as the other habits are: somebody who reads the line stacked on
 * their phone wants it stacked on both screens, tomorrow as well as today. A
 * device that has never chosen draws the line sideways, at every width, and
 * nothing is stored until the button is pressed.
 */
export function useLineLayout(): {
  vertical: boolean;
  setVertical: (vertical: boolean) => void;
} {
  const [vertical, setVertical] = useDeviceSetting('line:vertical', false);
  return { vertical, setVertical };
}
